<div class="flex items-start justify-between gap-4">
	<ng-content></ng-content>

	<div
		class="shrink-0"
		uiDropdown
		fullWidth="true"
		[openDropdownToTheLeft]="true"
		(openChange)="open.set($event)"
	>
		<button
			class="flex items-center cursor-pointer rounded-lg p-1 transition-colors"
			data-cy="c-ai-chat-usage-limit-toggle"
			uiDropdownTrigger
			[class.bg-primary-700]="open()"
		>
			<svg class="size-4 -rotate-90" viewBox="0 0 16 16" aria-hidden="true">
				<circle
					cx="8"
					cy="8"
					fill="none"
					[attr.r]="ringRadius"
					[attr.stroke]="open() ? trackColorOpen : trackColorClosed"
					[attr.stroke-width]="ringStroke"
				/>
				<circle
					cx="8"
					cy="8"
					fill="none"
					stroke-linecap="round"
					[attr.r]="ringRadius"
					[attr.stroke]="open() ? ringColorOpen : ringColorClosed"
					[attr.stroke-dasharray]="ringCircumference"
					[attr.stroke-dashoffset]="ringOffset()"
					[attr.stroke-width]="ringStroke"
				/>
			</svg>
		</button>

		<ng-container *uiDropdownContent>
			<div class="flex w-100 flex-col gap-1.5 p-4" data-cy="c-ai-chat-usage-limit">
				<div class="flex items-baseline justify-between gap-4 text-xs">
					<span class="text-secondary-900">
						{{ 'ai-chat.usage_limit.label' | translate: { days: windowDays() } }}
					</span>

					<span class="flex items-baseline gap-2">
						@if (resetLabel()) {
							<span class="text-secondary-600">
								{{ 'ai-chat.usage_limit.reset_in' | translate: { time: resetLabel() } }}
							</span>
						}
						<strong class="text-secondary-900">
							{{ percentUsed() | customNumber: integerDigitInfo }}{{ percentSuffix }}
						</strong>
					</span>
				</div>

				<div class="h-1 w-full overflow-hidden rounded-full bg-secondary-200">
					<div
						class="h-full rounded-full bg-secondary-900 transition-[width] duration-300"
						data-cy="c-ai-chat-usage-limit-bar"
						[style.width.%]="barPercent()"
					></div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
